var lib_core = require("lib-core");
var $ = require("jquery");

var SidebarView = function(model, masterView) {
    var self = this;

    this.model = model;
    this.masterView = masterView;

    this.template = this.getTemplate();

    //observe model for visibility
    this.model.show.onChange(this, function(){
        if(self.model.show()){
            self.template.show();
            $(window).resize().focus();
        }else{
            self.template.hide();
            $(window).resize().focus();
        }
    },1);

    // default hide
    self.template.hide();

};

SidebarView.prototype.getTemplate = function () {
    if (!this._template) {
        this._template = this.masterView.getTemplate().addSidebar();
    }
    return this._template;
};

module.exports = SidebarView;
